import { registerSW } from 'virtual:pwa-register';
import { toast } from '@aimmo/ui';

/**
 * Registers the service worker and asks before reloading.
 *
 * `registerType: 'prompt'` in the Vite config is the other half of this: an
 * automatic update would reload the page under someone who is mid-form, and
 * this app is mostly forms.
 */
export function registerServiceWorker(): void {
  const update = registerSW({
    onNeedRefresh() {
      toast('Nuova versione disponibile', {
        description: 'Ricarica per aggiornare AImmo.',
        duration: Infinity,
        action: { label: 'Ricarica', onClick: () => void update(true) },
      });
    },
    onOfflineReady() {
      toast('AImmo è disponibile offline', {
        description: "L'app si apre senza rete; i dati richiedono la connessione.",
      });
    },
  });
}
